import React from 'react';
import PropTypes from 'prop-types';

import InternalDocs from '../Department/Documents/internal-docs';

import { StyledBoxInside, StyledTitleWidget } from './style';

import { DirectorioBlanco } from '../../../../assets/images/index';

const RelevantDocumentation = props => (
  <StyledBoxInside>
    <StyledTitleWidget
      title={props.title}
      icon={DirectorioBlanco}
      small
      type="employeeDirectory"
    />
    <InternalDocs
      associationId={props.associationId}
      bcreadcrumbTitle={props.title}
      key={props.associationId}
      history={props.history}
    />
  </StyledBoxInside>
);

RelevantDocumentation.propTypes = {
  title: PropTypes.string.isRequired,
  associationId: PropTypes.number.isRequired
};

export default RelevantDocumentation;
